"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("lodash"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var LeftRailButton_1 = require("../../containers/LeftRailButton/LeftRailButton");
var cards_enum_1 = require("./cards.enum");
var ArticleCard_1 = require("./Cards/ArticleCard");
var PhotoCard_1 = require("./Cards/PhotoCard");
var VideoCard_1 = require("./Cards/VideoCard");
require("./styles.less");
var Timeline = /** @class */ (function (_super) {
    tslib_1.__extends(Timeline, _super);
    function Timeline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.resetFilters = function () {
            // tslint:disable-next-line
            var filterStore = _this.props.filterStore;
            // tslint:disable-next-line
            var timelineStore = _this.props.timelineStore;
            _this.removeHash();
            if (_.isEqual(mobx_1.toJS(filterStore.currentFilters), filterStore.defaultFilters)) {
                return;
            }
            filterStore.resetFilters();
            timelineStore.index = 1;
            timelineStore.resetTimeline();
            timelineStore.fetchTimeline();
        };
        _this.loadNextTimeline = function () {
            // tslint:disable-next-line
            var timelineStore = _this.props.timelineStore;
            timelineStore.changeTimelinePage(1);
            timelineStore.fetchTimeline();
        };
        return _this;
    }
    Timeline.prototype.componentDidMount = function () {
        // tslint:disable-next-line
        this.props.timelineStore.fetchTimeline();
    };
    Timeline.prototype.configureCards = function () {
        var _this = this;
        // tslint:disable-next-line
        return this.props.timelineStore.timelineData.cards.map(function (card, index) {
            switch (card.type) {
                case cards_enum_1.Cards.GS_VIDEO_CARD: {
                    var options = {
                        cardIndex: index,
                        card: card,
                    };
                    return (React.createElement(VideoCard_1.VideoCard, { options: options, key: card.identifier }));
                }
                case cards_enum_1.Cards.GS_ARTICLE_CARD: {
                    // tslint:disable-next-line
                    var urlHash = _this.props.globalStore.hashRouterService.createHashParam(_this.props.filterStore.currentFilters);
                    var options = tslib_1.__assign(tslib_1.__assign({ cardIndex: index }, card), { urlHash: urlHash, fromTimeline: true });
                    return (React.createElement(ArticleCard_1.ArticleCard, { options: options, key: card.identifier }));
                }
                case cards_enum_1.Cards.GS_PHOTO_CARD: {
                    var options = tslib_1.__assign(tslib_1.__assign({ cardIndex: index }, card), { fromTimeline: true });
                    return (React.createElement(PhotoCard_1.PhotoCard, { options: options, key: card.identifier }));
                }
                default: {
                    return null;
                }
            }
        });
    };
    Timeline.prototype.removeHash = function () {
        // tslint:disable-next-line
        this.props.globalStore.hashRouterService.removeHash();
    };
    Timeline.prototype.render = function () {
        // tslint:disable-next-line
        var timelineData = this.props.timelineStore.timelineData;
        var cards = [];
        var content;
        var showMore = null;
        if (timelineData.cards.length) {
            cards = this.configureCards();
        }
        if (timelineData.total > timelineData.index) {
            showMore = (React.createElement("div", { className: 'm-timeline-load' },
                React.createElement(LeftRailButton_1.LeftRailButton, { className: 'm-load-more', title: 'Load more', onClick: this.loadNextTimeline })));
        }
        if (cards.length) {
            content = (React.createElement(React.Fragment, null,
                cards,
                showMore));
        }
        else {
            content = (React.createElement("div", { className: 'm-timeline__empty' },
                React.createElement("p", { className: 'm-timeline-title__empty' }, "No results found"),
                React.createElement(LeftRailButton_1.LeftRailButton, { title: 'Clear filter', onClick: this.resetFilters })));
        }
        return (React.createElement("div", { className: 'm-gs-timeline' }, content));
    };
    Timeline = tslib_1.__decorate([
        mobx_react_1.inject('timelineStore', 'filterStore', 'globalStore'),
        mobx_react_1.observer
    ], Timeline);
    return Timeline;
}(React.Component));
exports.Timeline = Timeline;
